import {useCallback} from 'react';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { makeSelectAppLoggedIn } from '../../../app/appSelectors';
import { useLocation } from 'react-router';
import { Button } from 'react-bootstrap';
import { LANG_CHOOSER_TYPES, LangChooser } from '../../LangChooser';
import appHistory from '../../../app/appHistory';
import { useResponsive } from '../../../components/responsive';
import LogoComponent from '../../../components/LogoComponent/LogoComponent';
import {RouterPaths} from "../../../app/appConstants";
import {useSetBodyBackgroundColor} from "../../../components/UseSetBodyBackgroundColor/useSetBodyBackgroundHooks";
import {useGTMEvent} from "../../GoogleTagManager/googleTagManagerHooks";
import ProfileButton from "../../Account/components/ProfileButton/ProfileButton";
import { useLangContext } from "../../../providers/LangProvider/LangProviderContext";
import {
    LoginWrapperContentStyled,
    LoginWrapperHeaderStyled,
    LoginWrapperLangChooserContainerStyled,
    LoginWrapperMenuStyled,
    LoginWrapperStyled
} from "./styled/LoginWrapperStyled";

function LoginWrapper(props) {
    const { getLangPath } = useLangContext();
    const { isMediumMaxWidth, isSmallMaxWidth } = useResponsive();
    const { pathname } = useLocation();
    const { handleGTMClick, handleGTMClickLogoButton } = useGTMEvent({ module: 'Header' });
    useSetBodyBackgroundColor('var(--app-bg-modal-color)', isSmallMaxWidth);

    const isLoginPage = useCallback(() => {
        return pathname === RouterPaths.login;
    }, [pathname]);

    const changeSignHandler = useCallback(() => {
        appHistory.push(isLoginPage() ? RouterPaths.registration : RouterPaths.login);
        handleGTMClick({ button: isLoginPage() ? 'SignUp' : 'LogIn' });
    }, [handleGTMClick, isLoginPage]);

    return (
        <LoginWrapperStyled>
            <LoginWrapperHeaderStyled>
                <LogoComponent onClick={handleGTMClickLogoButton} />
                <LoginWrapperMenuStyled>
                    {props.loggedIn ? (
                            <ProfileButton/>
                    ) : (
                            <>
                                {!props.hideAuthButton && !isSmallMaxWidth && (
                                        <div>{isLoginPage() ? getLangPath('promo.fx.start.not_user') : getLangPath('promo.fx.start.already_user')}</div>
                                )}
                                {!props.hideAuthButton && <Button variant={'outline-primary'} size={'sm'} onClick={changeSignHandler}>
                                        {isLoginPage() ? getLangPath('sign_up.title') : getLangPath('promo.fx.log_in')}
                                    </Button>
                                }
                                <LoginWrapperLangChooserContainerStyled>
                                    <LangChooser
                                            isHideButtonArrowIcon={isMediumMaxWidth}
                                            isHideButtonName={isSmallMaxWidth}
                                            gtmModule="Header"
                                            type={isMediumMaxWidth ? LANG_CHOOSER_TYPES.slider : LANG_CHOOSER_TYPES.dropdown}
                                    />
                                </LoginWrapperLangChooserContainerStyled>
                            </>
                    )}
                </LoginWrapperMenuStyled>
            </LoginWrapperHeaderStyled>
            <LoginWrapperContentStyled>{props.children}</LoginWrapperContentStyled>
        </LoginWrapperStyled>
    );
}

const mapStateToProps = createStructuredSelector({
    loggedIn: makeSelectAppLoggedIn(),
});

export default connect(mapStateToProps)(LoginWrapper);
